import '|/app.styl';

// Scripts

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Ready to go

        // Run our utility scripts

    });

})(jQuery);